/**
 * @FIXME Temporary fix to #676 -- See if we can remove this file with Keycloak 26.5.
 *
 * @see https://github.com/keycloak/keycloak-quickstarts/issues/676
 */
import {
    KeycloakMasthead,
    label,
} from "@keycloak/keycloak-ui-shared";
import {
    useEnvironment,
    type AccountEnvironment,
} from "@keycloak/keycloak-account-ui";
import { Button } from "@patternfly/react-core";
import { ExternalLinkSquareAltIcon } from "@patternfly/react-icons";
import { useTranslation } from "react-i18next";
import { useHref } from "react-router-dom";

import { joinPath } from "../utils/joinPath";

const ReferrerLink = () => {
    const { environment } = useEnvironment<AccountEnvironment>();
    const { t } = useTranslation();

    return environment.referrerUrl ? (
        <Button
            data-testid="referrer-link"
            component="a"
            href={environment.referrerUrl.replace("_hash_", "#")}
            variant="link"
            icon={<ExternalLinkSquareAltIcon />}
            iconPosition="right"
            isInline
        >
            {t("backTo", {
                app: label(t, environment.referrerName, environment.referrerUrl),
            })}
        </Button>
    ) : null;
};

export const Header = () => {
    const { environment, keycloak } = useEnvironment();
    const { t } = useTranslation();

    const brandImage = environment.logo || "logo.svg";
    const logoUrl = environment.logoUrl ? environment.logoUrl : "/";
    const internalLogoHref = useHref(logoUrl);

    // User can indicate that he wants an internal URL by starting it with "/"
    const indexHref = logoUrl.startsWith("/") ? internalLogoHref : logoUrl;

    return (
        <KeycloakMasthead
            data-testid="page-header"
            keycloak={keycloak}
            features={{ hasManageAccount: false }}
            brand={{
                href: indexHref,
                src: joinPath(environment.resourceUrl, brandImage),
                alt: t("logo"),
                // className: style.brand,
            }}
            toolbarItems={[<ReferrerLink key="link" />]}
        />
    );
};
